import { EADDRESS_TYPES } from "@constants";
import { IUserAddress } from "@common/Eircode/interface/IAddressForm";

export interface IUserAddressPayload {
    addressLine1: string;
    addressLine2?: string;
    addressLine3?: string;
    code?: string;
    county: string;
    town: string;
    type?: EADDRESS_TYPES;
}

export const getStateToPayload = (formData: IUserAddress): IUserAddressPayload => ({
    addressLine1: formData.addressLine1,
    addressLine2: formData.addressLine2,
    addressLine3: formData.addressLine3,
    code: formData.code?.replace(/\s/g, ""),
    county: formData.county,
    town: formData.town,
    type: EADDRESS_TYPES.BILLING,
});
